import { Component, Input, OnInit } from '@angular/core';
import { Utils } from 'src/app/@shared/utils/utils';
import { CobrancaBoletoDTO, CobrancaDTO } from 'src/app/core/types';

@Component({
  selector: 'app-boleto-payment',
  templateUrl: './payment-boleto.component.html',
  styleUrls: ['./payment-boleto.component.scss'],
})
export class PaymentBoletoComponent implements OnInit {
  @Input() cobranca: CobrancaDTO = {} as CobrancaDTO;

  ngOnInit(): void {
    if (this.cobranca.formaPagamento.nome === 'Boleto') {
      window.open(this.getBoletoDetails().pdf, '_blank');
    }
  }

  getVencimentoBoleto(): string {
    const pix = this.cobranca.formaPagamento as CobrancaBoletoDTO;
    return `Pagamento válido até ${Utils.formatDateString(pix.dataVencimento)}`;
  }

  getBoletoDetails(): CobrancaBoletoDTO {
    return this.cobranca.formaPagamento as CobrancaBoletoDTO;
  }
}
